<template>
  <div class="about">
    <h1>This is an about page {{user.name}}</h1>
  </div>
</template>

<script>
export default {
  computed: {
    user(){
      return this.$store.state.user;
    }
  }
}
</script>
